import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const TRUCK_IMG =
  "https://customer-assets-agu9un31.emergentagent.net/job_bennici-fleet-1/artifacts/urah3qfm_IMG_7635.jpeg";

const POINTS = [
  "Esperienza consolidata",
  "Servizio personalizzato",
  "Flotta moderna",
  "Punto di riferimento affidabile",
];

export default function About() {
  return (
    <section
      id="chi-siamo"
      data-testid="about-section"
      className="relative py-24 md:py-36 overflow-hidden"
    >
      {/* Background accents */}
      <div className="absolute -top-32 right-0 h-[420px] w-[420px] rounded-full bg-[#0055ff] opacity-[0.07] blur-[140px]" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Text column */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-7"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-blue-400" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.32em] text-blue-300">
              Chi Siamo
            </span>
          </div>

          <h2
            data-testid="about-title"
            className="font-heading text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-[-0.02em] leading-[1.02] text-white"
          >
            Trasporti professionali,{" "}
            <span className="metal-text-gradient">sicuri</span> e{" "}
            <span className="steel-text-gradient">puntuali.</span>
          </h2>

          <div className="mt-8 space-y-5 text-gray-300 text-base md:text-lg leading-relaxed max-w-2xl">
            <p>
              <span className="text-white font-medium">
                Bennici Autotrasporti
              </span>{" "}
              è un&apos;azienda specializzata nei trasporti e nella logistica,
              impegnata a offrire servizi professionali, sicuri e puntuali.
            </p>
            <p>
              La nostra esperienza ci permette di gestire ogni esigenza di
              trasporto con precisione e attenzione, diventando un{" "}
              <span className="text-blue-300">
                punto di riferimento affidabile
              </span>{" "}
              per i nostri clienti.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-2 gap-4 max-w-xl">
            {POINTS.map((p, i) => (
              <motion.div
                key={p}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.1 * i }}
                className="flex items-center gap-3 text-sm text-gray-200"
                data-testid={`about-point-${i}`}
              >
                <CheckCircle2
                  size={18}
                  className="text-blue-400 flex-shrink-0"
                  strokeWidth={2.5}
                />
                <span>{p}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Image column */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5 relative"
        >
          <div className="absolute -inset-6 bg-[#0055ff] opacity-25 blur-[80px] rounded-full" />
          <div className="relative overflow-hidden border border-white/10 bg-[#0a0d14]">
            <img
              src={TRUCK_IMG}
              alt="Renault T29 Bennici Autotrasporti — mezzo moderno refrigerato"
              className="w-full h-[460px] md:h-[620px] object-cover"
              data-testid="about-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
            {/* Floating spec card */}
            <div className="absolute bottom-6 left-6 right-6 glass-panel p-5 border-blue-500/20">
              <div className="text-[10px] uppercase tracking-[0.3em] text-blue-300/80 mb-2">
                Flotta operativa · Renault T29
              </div>
              <div className="font-heading text-xl font-bold text-white">
                Mezzi moderni · Tracciamento attivo
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
